import { HtmlContent } from "./TabContent/GeneralInfo";
import BasicDataContent from "./TabContent/Basicdata";
import { CommercialContent } from "./TabContent/CommercialTerms";
import { TradeContent } from "./TabContent/TradeSupport";
import { DocumentContent } from "./TabContent/Document";
import { useState } from "react";
import PremiumHeader from "./PremiumHeader";
import "./SlideTransition.css";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import { useGenralInfoFormStore } from "../../../store/vendorRegistrationStore/useGeneralInfoFormStore";
import { message } from "antd";
import { useBasicDataFormStore } from "../../../store/vendorRegistrationStore/useBasicDataFormStore";
import { useCommercialStore } from "../../../store/vendorRegistrationStore/useCommercialStore";
import { useTradeStore } from "../../../store/vendorRegistrationStore/useTradeStore";
import { useDocumentStore } from "../../../store/vendorRegistrationStore/useDocumentStore";

const ReactApp = () => {
  const { submitGenralInfo, vendorDetailByGuid } = useVendorMasterStore();
  const [currentStep, setCurrentStep] = useState(1);
  const [slideDirection, setSlideDirection] = useState("");
  const submitted = localStorage.getItem("submitted") === "Yes";
  const showStep4 = localStorage.getItem("ShowStep4") === "Yes";
  const { VendorType } = vendorDetailByGuid?.Vendor || {};

  let steps = [
    {
      title: "General Info",
      component: HtmlContent,
    },
    {
      title: "Basic Data",
      component: BasicDataContent,
    },
    {
      title: "Commercial Terms",
      component: CommercialContent,
    },
    showStep4 && VendorType !== "ZAEX" && {
      title: "Trade Support Terms",
      component: TradeContent,
    },
    {
      title: "Document",
      component: DocumentContent,
    },
  ].filter(Boolean);

  const handleNext = async () => {
    if (!submitted) {
      if (currentStep === 1) {
        const { formData, setErrors, validateForm, setField } =
          useGenralInfoFormStore.getState();
        const isValid = validateForm();
        if (!isValid) {
          return;
        }
        try {
          const response = await submitGenralInfo(formData);

          if (!response.status) {
            message.error("API Error:", response);
            return;
          }
          useBasicDataFormStore
            .getState()
            .setLocationData(formData.addresses[0]);
        } catch (error) {
          console.error("API Call Failed:", error);
          return;
        }
      }
      if (currentStep === 2) {
        const { basicData, validateForm, submitBasicInfo } =
          useBasicDataFormStore.getState();
        const isValid = validateForm();
        if (!isValid) {
          return;
        }
        try {
          const response = await submitBasicInfo(basicData);
          console.log("Basic Data Response:", response);
          if (!response.status) {
            message.error("API Error:", response);
            return;
          }
        } catch (error) {
          console.error("API Call Failed:", error);
          return;
        }
      }
      if (currentStep === 3) {
        const { validateForm, submitCommercialTerms } =
          useCommercialStore.getState();
        const isValid = validateForm();
        if (!isValid) {
          return;
        }
        try {
          const response = await submitCommercialTerms();
          console.log("Commercial Terms Response:", response);
          if (!response.status) {
            message.error(
              "API Error:",
              response?.message || "Submission failed",
            );
            return;
          }
        } catch (error) {
          console.error("API Call Failed:", error);
          return;
        }
      }
    }
    if (currentStep === 4 && submitted && showStep4) {
      const { validateForm, submitTradeSupport, hasTradeChanged } =
        useTradeStore.getState();
      const isValid = validateForm();
      if (!isValid) {
        return;
      }
      if (!hasTradeChanged()) {
        // console.log("No changes in Trade Support. Skipping API call.");
      } else {
        try {
          const response = await submitTradeSupport();
          if (!response.status) {
            message.error(
              "API Error:",
              response?.message || "Submission failed",
            );
            return;
          }
        } catch (error) {
          console.error("API Call Failed:", error);
          return;
        }
      }
    }

    // Slide to next step if everything is fine
    if (currentStep < steps.length) {
      setSlideDirection("slide-left");
      setTimeout(() => {
        setCurrentStep(currentStep + 1);
        setSlideDirection("");
      }, 300);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setSlideDirection("slide-right");
      setTimeout(() => {
        setCurrentStep(currentStep - 1);
        setSlideDirection("");
      }, 300);
    }
  };

  const handleReset = () => {
    setSlideDirection("slide-right");
    setTimeout(() => {
      setCurrentStep(1);
      setSlideDirection("");
    }, 300);
  };
  const handleSubmit = async () => {
    const { validateForm, submitDocumentData, showModal } =
      useDocumentStore.getState();
    const isValid = validateForm();
    if (!isValid) {
      return;
    }
    try {
      const response = await submitDocumentData();
      if (!response.status) {
        message.error("API Error:", response?.message || "Submission failed");
        return;
      }
      // closeTab("new_registration");

      // // Optional: clear storage
      // localStorage.removeItem("vendorGUID");
      // localStorage.removeItem("submitted");
      // localStorage.removeItem("showApprove");
      showModal(true);
      // addNewTab([
      //   ...openTabs,
      //   {
      //     closable: true,
      //     key: "vendor_profile",
      //     label: "View Vendor Profile",
      //   },
      // ]);
      // setActiveTab("vendor_profile");
    } catch (error) {
      console.error("API Call Failed:", error);
      return;
    }
  };

  const CurrentComponent = steps[currentStep - 1].component;

  return (
    <div className="newregister-main-container">
      <PremiumHeader
        currentStep={currentStep}
        stepTitle={steps[currentStep - 1].title}
        totalSteps={steps.length}
        steps={steps.map((s) => s.title)}
        onNext={handleNext}
        onPrevious={handlePrevious}
        onReset={handleReset}
        onSubmit={handleSubmit}
        showStep4={showStep4}
      />

      <div className={`newregister-content-wrapper ${slideDirection}`}>
        <CurrentComponent
          onNext={handleNext}
          onPrevious={handlePrevious}
          onSubmit={handleSubmit}
          currentStep={currentStep}
          totalSteps={steps.length}
          // submitted={submitted}
        />
      </div>
    </div>
  );
};

export default ReactApp;
